var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMinimizeBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1501,
    height: 1380,
    viewBox: "0 0 1501 1380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1134.49 589.588C993.219 566.846 885.315 444.367 885.315 296.688C885.315 132.829 1018.14 6.10352e-05 1182 6.10352e-05C1313.67 6.10352e-05 1425.3 85.7668 1464.08 204.475C1486.65 273.438 1500.24 347.688 1500.24 424.192C1500.24 670.196 1374.02 886.726 1182.81 1012.54L1182.8 1012.53C1171.86 1019.92 1158.67 1024.23 1144.47 1024.23C1106.61 1024.23 1075.91 993.543 1075.91 955.676C1075.91 938.209 1082.44 922.272 1093.19 910.163C1153.1 842.472 1190.33 754.309 1192.48 657.342C1192.48 623.03 1167.27 594.605 1134.36 589.576L1134.49 589.588Z",
    fill: "#010303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M728.173 689.521C728.173 308.709 511.827 0 244.956 0H68.7229C50.6645 0.00416667 32.6354 7.09165 19.1645 21.1708C-7.02718 48.5417 -6.33965 92.2001 21.027 118.392C149.198 242.384 233.423 451.917 233.423 689.521C233.423 1070.33 449.773 1379.04 716.64 1379.04H892.873C910.932 1379.04 928.961 1371.95 942.436 1357.87C968.628 1330.5 967.94 1286.84 940.569 1260.65C812.403 1136.66 728.178 927.126 728.178 689.521H728.173Z",
    fill: "#010303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMinimizeBlack);
export default __webpack_public_path__ + "static/media/logo-minimize-black.60f96a5dd06c768336ef668d5ba029ff.svg";
export { ForwardRef as ReactComponent };